module.exports = __webpack_public_path__ + "static/media/ck2_preview.52f78030.png";